import { z } from 'zod';

/**
 * Lecture et validation des variables d'environnement du frontend.
 *
 * Regle : l'application doit DEMARRER meme si Supabase n'est pas encore
 * configure (utile tant que le projet Supabase n'existe pas). Dans ce cas
 * `isSupabaseConfigured` vaut false et l'interface affiche un bandeau explicite
 * plutot que de planter au chargement.
 */

const schema = z.object({
  VITE_SUPABASE_URL: z.string().url().optional(),
  VITE_SUPABASE_ANON_KEY: z.string().min(20).optional(),
  VITE_SITE_NAME: z.string().default('BD Innovation'),
  VITE_SITE_URL: z.string().url().default('http://localhost:5173'),
  VITE_APP_ENV: z.enum(['development', 'staging', 'production']).default('development'),
});

const parsed = schema.safeParse(import.meta.env);

if (!parsed.success) {
  // On n'interrompt pas le rendu : on signale clairement le probleme en console.
  console.error(
    '[BD] Variables d’environnement invalides :',
    parsed.error.flatten().fieldErrors,
  );
}

const raw = parsed.success ? parsed.data : schema.parse({});

export const env = {
  supabaseUrl: raw.VITE_SUPABASE_URL ?? '',
  supabaseAnonKey: raw.VITE_SUPABASE_ANON_KEY ?? '',
  siteName: raw.VITE_SITE_NAME,
  siteUrl: raw.VITE_SITE_URL,
  appEnv: raw.VITE_APP_ENV,
  isProduction: raw.VITE_APP_ENV === 'production',
} as const;

/** true uniquement si l'URL et la cle anon sont toutes les deux presentes. */
export const isSupabaseConfigured = Boolean(env.supabaseUrl && env.supabaseAnonKey);
